import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { CreateFunctionality, Functionality, FunctionalityListResponse, FunctionalityQueryParams, UpdateFunctionality } from '@frontend/functionality/types';

export class FunctionalityClient extends APIClient {
    public static readonly endpoint = '/functionality-api/v1';

    public static async fetchFunctionalities(queryParams?: ApiQueryParams<FunctionalityQueryParams>, withCredentials?: Token, includeAccessToken?: boolean): Promise<FunctionalityListResponse> {
        return await this.apiPaginated<FunctionalityListResponse, FunctionalityQueryParams>(`${this.endpoint}/functionalities`, queryParams, withCredentials, includeAccessToken);
    }
    public static async resolveFunctionalities(ids: string[], field: string = 'id'): Promise<FunctionalityListResponse> {
        return this.resolve<FunctionalityListResponse>(`${this.endpoint}/functionalities`, ids, field);
    }

    public static async deleteFunctionalities(functionalityIds: string[]): Promise<void> {
        const response = await this.post(`${this.endpoint}/functionalities-delete`, { ids: functionalityIds });
        return await this.handleVoidResponse(response);
    }

    public static async postFunctionality(accountId: string, functionality: CreateFunctionality): Promise<Functionality> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/functionalities`, functionality);
        return await this.handleResponse<Functionality>(response);
    }

    public static async fetchFunctionality(accountId: string, functionalityId: string): Promise<Functionality> {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/functionalities/${functionalityId}`);
        return await this.handleResponse<Functionality>(response);
    }

    public static async patchFunctionality(accountId: string, functionalityId: string, body: UpdateFunctionality): Promise<Functionality> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/functionalities/${functionalityId}`, body);
        return await this.handleResponse<Functionality>(response);
    }

    public static async deleteFunctionality(accountId: string, functionalityId: string): Promise<void> {
        const response = await this.delete(`${this.endpoint}/accounts/${accountId}/functionalities/${functionalityId}`);
        return await this.handleVoidResponse(response);
    }
}
